import { useFormContext } from 'react-hook-form'
import { useBlockAction } from '@editorHooks'
import { ANCHOR_GRID_BLOCK_ACTION } from '../constants'

/**
 * Registers a block for {@link ANCHOR_GRID_BLOCK_ACTION} while the Zugverbindertabelle form has
 * unsaved changes, so subscribers (Escape, the bottom toolbar toggle, the close button) can prevent
 * closing the table until it is saved. Renders nothing; must live inside the table's Form.
 */
const AnchorGridDirtyBlocker = (): null => {
  const {
    formState: { isDirty },
  } = useFormContext()

  useBlockAction(ANCHOR_GRID_BLOCK_ACTION, isDirty ? 'provider' : undefined)

  return null
}

export default AnchorGridDirtyBlocker
